module.exports = __webpack_public_path__ + "ddc4493802a9430e4be5cbfa95d85087.gif";